
import { Card, CardContent, CardHeader, CardTitle, CardFooter } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Skeleton } from '@/components/ui/skeleton';
import { useWishlist } from '@/hooks/useWishlist';
import { Heart, ArrowRight } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';

const WishlistPreview = () => {
  const { wishlist, isLoading } = useWishlist();
  const navigate = useNavigate();
  const previewItems = wishlist.slice(0, 4);

  return (
    <Card className="profile-card border-0 overflow-hidden">
      <CardHeader className="bg-gradient-secondary/30 border-b">
        <CardTitle className="flex items-center gap-3 font-playfair text-xl">
          <div className="p-2 bg-rose-500/10 rounded-lg">
            <Heart className="h-5 w-5 text-rose-500" />
          </div>
          Wishlist Preview
        </CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading && (
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {Array.from({ length: 4 }).map((_, i) => (
              <Skeleton key={i} className="aspect-square w-full rounded-lg" />
            ))}
          </div>
        )}
        {!isLoading && previewItems.length === 0 && (
          <div className="text-center py-4 text-muted-foreground">
            <Heart className="h-8 w-8 mx-auto mb-2" />
            <p>Your wishlist is empty.</p>
            <Button variant="link" onClick={() => navigate('/products')}>Browse products</Button>
          </div>
        )}
        {!isLoading && previewItems.length > 0 && (
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-6">
            {previewItems.map((item) => (
              <Link to={`/product/${item.products.id}`} key={item.id} className="group">
                <div className="aspect-square w-full bg-gradient-muted rounded-xl overflow-hidden relative shadow-card group-hover:shadow-card-hover transition-all duration-300">
                  <img
                    src={item.products.image_url}
                    alt={item.products.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-all duration-300" />
                </div>
                <p className="text-sm font-semibold truncate mt-3 text-foreground group-hover:text-primary transition-colors">{item.products.name}</p>
                <p className="text-sm text-muted-foreground font-medium font-playfair">${Number(item.products.price).toFixed(2)}</p>
              </Link>
            ))}
          </div>
        )}
      </CardContent>
      {wishlist.length > 0 && (
        <CardFooter className="bg-gradient-secondary/20 border-t">
          <Button variant="outline" className="w-full hover:bg-rose-500 hover:text-white transition-all duration-300 font-medium" onClick={() => navigate('/wishlist')}>
            View Full Wishlist <ArrowRight className="h-4 w-4 ml-2" />
          </Button>
        </CardFooter>
      )}
    </Card>
  );
};

export default WishlistPreview;
